var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-6"},_vm._l((_vm.briefings),function(briefing,idx){return _c('div',{key:idx},[_c('briefings-card',{attrs:{"title":briefing.title,"text":briefing.text}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }